import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Member, UpdateMember } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { memberQueryKeys } from "./keys";


export const useUpdateMember = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, UpdateMember>({
        mutationKey: ["member", "update", agentId],
        mutationFn: async (form: UpdateMember) => {
            try {
                if (!form.member_id) {
                    return;
                }
                const { data } = await memberRepository.update(agentId, form.member_id, form);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: memberQueryKeys.all(agentId)
            });
        }
    });
};
